<div class="phone-input" [formGroup]="internalForm">
	<div
		class="phone-input__prefix select select--filled"
		[class.select--open]="prefixMenuOpen"
	>
		<button
			type="button"
			class="select__trigger input phone-input__prefix-trigger"
			[class.input--error]="hasError"
			[disabled]="disabled"
			[attr.aria-expanded]="prefixMenuOpen"
			aria-haspopup="listbox"
			(click)="togglePrefixMenu($event)"
		>
			<span class="table-nationality-flag-wrap phone-input__prefix-display">
				@if (selectedPrefixIso2()) {
					<img
						class="table-nationality-flag"
						[src]="countryFlagImageUrl(selectedPrefixIso2())"
						alt=""
						loading="lazy"
					/>
				}
				<span class="phone-input__prefix-code">{{ selectedDialCode() }}</span>
			</span>
			<tec-icon name="icon-chevron-down" />
		</button>

		@if (prefixMenuOpen) {
			<div
				class="select__menu select__menu--visible select__menu--search"
				role="listbox"
				(click)="$event.stopPropagation()"
			>
				<div class="select__menu__header">
					<tec-input-search
						(click)="$event.stopPropagation()"
						[size]="'sm'"
						[formControl]="prefixSearch"
						[placeholder]="'TEC.INPUT_SEARCH.PLACEHOLDER' | translate"
						(searchInput)="onPrefixSearchInput($event)"
						(input)="onPrefixSearchInput($event)"
					/>
				</div>
				<div class="select__menu__items">
					@for (option of filteredPrefixOptions; track option.id) {
						<div
							class="items__item phone-input__option table-nationality-flag-wrap"
							role="option"
							[class.items__item--selected]="option.id === selectedPrefixId()"
							(click)="selectPrefix(option, $event)"
						>
							@if (getPrefixIso2(option)) {
								<img
									class="table-nationality-flag"
									[src]="countryFlagImageUrl(getPrefixIso2(option))"
									alt=""
									loading="lazy"
								/>
							}
							<span class="phone-input__option-name">{{ getPrefixCountryName(option) }}</span>
							<span class="phone-input__option-code">{{ getPrefixDialCode(option) }}</span>
						</div>
					} @empty {
						<div class="items__no-results">{{ 'TEC.GENERIC.NO_RESULT' | translate }}</div>
					}
				</div>
			</div>
		}
	</div>

	<tec-input
		class="phone-input__number"
		type="text"
		formControlName="number"
		[hasError]="hasError"
		[disabled]="disabled"
		(focusin)="onNumberFocus()"
	/>
</div>
